module.exports = __webpack_public_path__ + "static/IBMPlexSans-Regular-d729a94ca6f60fda67469fe100927de6.woff2";